const ErrorInterceptors = () => {
	const addErrorInterceptor = (serviceInstance) => {
		serviceInstance.interceptors.response.use(
			(res) => res,
			(err) => {
				// Throwing error here will convert the unhandled exception into a handled one.
				throw err;
			}
		);
	};

	return {
		addErrorInterceptor
	};
};

export default ErrorInterceptors();
